import * as FlatModels from '@medsurf/flat-models';

// <editor-fold desc="Action Types">

/**
 * Action types
 */
export enum ActionTypes {
  /**
   * Store
   */
  ToggleNode = '[STORE | AUTHOR | BOOKMARK] Toggle Node',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Toggle Node
 */
export class ToggleNode {
  public static readonly type = ActionTypes.ToggleNode;

  public constructor(public node: FlatModels.NodeEntityModels.NodeEntityType,
                     public page: FlatModels.PageEntityModels.PageEntityType) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>
